import { gql, useQuery } from '@provision/graphql-client';
import { useEffect, useState } from 'react';

const GET_ORIGINAL_EMAIL = gql`
  query GetOriginalEmail($conversationMessageId: String!) {
    getOriginalEmail(params: { conversationMessageId: $conversationMessageId }) {
      from
      to
      cc
      subject
      text
      source
      html
      fileUrl
    }
  }
`;

interface OriginalEmailInfo {
  from: string;
  to: string;
  cc: string;
  subject: string;
  text: string;
  source: string;
  html: string;
  fileUrl?: string;
}

interface GetOriginalEmailQuery {
  getOriginalEmail: OriginalEmailInfo;
}

export const useOriginalEmail = (conversationMessageId: string) => {
  const [originalEmailInfo, setOriginalEmailInfo] = useState<OriginalEmailInfo | null>(null);

  const { data, ...rest } = useQuery<GetOriginalEmailQuery>(GET_ORIGINAL_EMAIL, {
    variables: { conversationMessageId },
    skip: !conversationMessageId,
  });

  useEffect(() => {
    if (!data?.getOriginalEmail) return;

    if (!data.getOriginalEmail.fileUrl) {
      setOriginalEmailInfo(data.getOriginalEmail);
      return;
    }
    fetchEmailFile(data.getOriginalEmail.fileUrl)
      .then(setOriginalEmailInfo)
      .catch(console.error);
  }, [data]);

  return { originalEmailInfo, ...rest };
};

async function fetchEmailFile(getUrl: string): Promise<OriginalEmailInfo | null> {
  try {
    const response = await fetch(getUrl);
    if (!response.ok) {
      throw new Error(`Couldn't fetch email: ${response.statusText}`);
    }
    const data = (await response.json()) as OriginalEmailInfo;
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
}
